define('AwaLabs.CoreContentFix.Main', [
    'CXExtensibility.CoreContent.CMSMerchzoneCCT',
    'CXExtensibility.CoreContent.CMSMerchzoneCCT.View',
    'underscore'
],
function (
    CXExtensibilityCoreContentCMSMerchzoneCCT,
    CMSMerchzoneCCTView,
    _
) {

    CXExtensibilityCoreContentCMSMerchzoneCCT.mountToApp = function (container) {
        var environment = container.getComponent('Environment');
        if (SC.ENVIRONMENT.jsEnvironment === 'browser' && environment) {
            environment.setTranslation('fr_CA', [{ key: 'See More', value: 'Voir Plus' }]);
            environment.setTranslation('es_ES', [{ key: 'See More', value: 'Ver Más' }]);

            container.getComponent('CMS').registerCustomContentType({
                // this property value MUST be lowercase
                id: 'CMS_MERCHZONETWO',

                // The view to render the CCT
                view: CMSMerchzoneCCTView,
            });
        }
    }
});
